var RoundDirection;
(function(RoundDirection) {
    RoundDirection["Up"] = "up";
    RoundDirection["Down"] = "down";
})(RoundDirection || (RoundDirection = {}));
function polarToCartesian(param) {
    var r = param.r, t = param.t;
    return {
        x: r * Math.cos(t),
        y: r * Math.sin(t)
    };
}
function cartesianToPolar(param) {
    var x = param.x, y = param.y;
    return {
        r: Math.sqrt(x * x + y * y),
        t: Math.atan2(y, x)
    };
}
// a better `mod` function than JS native % operator,
// since the % operator returns invalid mod values for negative numbers :shrug:
function mod(i, n) {
    return (i % n + n) % n;
}
// returns the sign of the number (0/-1/+1)
function sign(val) {
    if (val === 0) return 0;
    return val > 0 ? 1 : -1;
}
// clamps a number between `min` and `max`
function clamp(min, max, val) {
    return min < max ? Math.max(min, Math.min(val, max)) : Math.min(min, Math.max(val, max));
}
// lerp (AKA linear interpolation) returns the relative number (t, a value in the range [0...1]), between your `min` and `max` values.
// e.g.: lerp(0, 10, 0.4) === 4
//       lerp(0, 10, 1.1) === 11
function lerp(min, max, t) {
    return min + (max - min) * t;
}
// clampedLerp is the same the `lerp`, but it clamps the returned value between `min` and `max`
// (so given a `t` value which is larger than 1 or lower than 0, the returned value will still be in the `min`-`max` bounds).
// e.g.: lerp(0, 10, 1.1) === 11
//       clampedLerp(0, 10, 1.1) === 10
function clampedLerp(min, max, t) {
    return clamp(min, max, lerp(min, max, t));
}
// inversedLerp is like lerp, but uh, inversed. this mean you get the relative number `t` for the `value` between `min`-`max`.
// e.g.: inverseLerp(0, 10, 4) === 0.4
//       inverseLerp(0, 10, 11) === 1.1
function inversedLerp(min, max, value) {
    if (max - min === 0) return Number.NaN;
    return (value - min) / (max - min);
}
// clampedInversedLerp clamps the result of `t` between 0 and 1, even if the provided `value` is outside the range of `min`-`max`
// e.g.: clampedInverseLerp(0, 10, 4) === 0.4
//       clampedInverseLerp(0, 10, 11) === 1.0
function clampedInversedLerp(min, max, value) {
    return clamp(0, 1, inversedLerp(min, max, value));
}
// returns the points of an easing function over a given interval from 0 to 1
function interpolatePoints(easingFunction, interval) {
    var clampedInterval = clamp(0, 1, interval);
    var count = 1 / interval + 1;
    var points = [];
    for(var i = 0; i < count; i++){
        var x = easingFunction(i * clampedInterval);
        points.push({
            x: x,
            y: easingFunction(x)
        });
    }
    return points;
}
function lerpColor(hexFrom, hexTo, value) {
    var ah = Number(hexFrom.replace("#", "0x")), ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff, bh = Number(hexTo.replace("#", "0x")), br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff, rr = ar + value * (br - ar), rg = ag + value * (bg - ag), rb = ab + value * (bb - ab);
    return "#".concat(((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1));
}
// COMMON DEGREES
var DEGREES_180 = 180;
/**
 * Converts degrees to radians
 * @param deg degrees to convert
 * @returns degrees in radians
 */ var degToRad = function(deg) {
    return deg / DEGREES_180 * Math.PI;
};
/**
 * Converts radians to degrees
 * @param rad radians to convert
 * @returns radians in degrees
 */ var radToDeg = function(rad) {
    return rad * (DEGREES_180 / Math.PI);
};
var clampToInterval = function(value, min, max, interval, roundDirection) {
    if (value >= max) {
        return max;
    }
    if (value <= min) {
        return min;
    }
    if (roundDirection === RoundDirection.Down) {
        return Math.floor((value - min) / interval) * interval + min;
    }
    if (roundDirection === RoundDirection.Up) {
        return Math.ceil((value + min) / interval) * interval - min;
    }
    return Math.round(value / interval) * interval;
};

export { DEGREES_180, RoundDirection, cartesianToPolar, clamp, clampToInterval, clampedInversedLerp, clampedLerp, degToRad, interpolatePoints, inversedLerp, lerp, lerpColor, mod, polarToCartesian, radToDeg, sign };
